import { VM_STICKER } from 'Root/constants';

const stickerImageHandler = (isSticker, sticker, vmRef) => {
  const stickerPath = require(`../../../assets/imgs/sticker/variantStickers/${sticker}.gif`);
  const vmIframe =
    document.getElementById('YMK-module-iframe') &&
    document.getElementById('YMK-module-iframe').contentDocument;
  const isEmpty = vmIframe === null;
  if (isEmpty) return;

  const createImageElement = () => {
    // VM width and height
    const { clientWidth, clientHeight } =
      vmRef && vmRef.current && vmRef.current.firstChild;

    let elem = document.createElement('img');
    elem.setAttribute('id', 'vmSticker');
    elem.setAttribute('alt', '');
    elem.setAttribute('top', '80px');
    elem.setAttribute('left', '20px');
    elem.setAttribute('opacity', '0.2');
    elem.style = `position: absolute; width: ${clientWidth}px; height: ${clientHeight}px`;

    return elem;
  };

  const getVmLocation = () => {
    const vmImg = vmIframe.getElementById('result-target');
    const firstChild = vmImg && vmImg.firstElementChild;
    if (firstChild !== null) {
      firstChild.style.position = 'absolute';
    }
    const getStyle = vmImg.style;
    getStyle.overflow = 'visible';

    return vmImg;
  };

  const gifImageElement = createImageElement();
  const vmLocationImg = getVmLocation();

  const clearImageElement = () => {
    const children = vmLocationImg.childNodes;
    for (let index = 0; index < children.length; index++) {
      const child = children[index];
      if (child.id === VM_STICKER) {
        vmLocationImg.removeChild(child);
      }
    }
  };

  if (isSticker) {
    gifImageElement.src = stickerPath;
    clearImageElement();
    vmLocationImg.appendChild(gifImageElement);
  } else {
    clearImageElement();
  }
};

export default stickerImageHandler;
